<template>
  <div class="uk-container">
    Insufficient Permissions
  </div>
</template>

<script>
export default {
  name: 'ViewErrorInsufficientPermissions'
}
</script>
